module.exports = new __parcel__URL__("puppy3.73455761.png").toString();